"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightInfoTable = void 0;
const react_1 = __importDefault(require("react"));
const Table_1 = require("../../../../../Table");
require("./index.scss");
const className = 'flight-info-table';
const FlightInfoTable = (props) => {
    const { columns, data, } = props;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Table_1.Table, { columns: columns, data: data })));
};
exports.FlightInfoTable = FlightInfoTable;
//# sourceMappingURL=index.js.map